import gql from 'graphql-tag';

export const DepartmentFragment = gql`
  fragment DepartmentFragment on Department {
    id
    name
    logo
    roundSeats
    score(year: 2562) {
      id
      year
      scoreType
      min
      max
      avg
    }
    scoreY1: score(year: 2561) {
      id
      year
      scoreType
      min
      max
      avg
    }
    scoreY2: score(year: 2560) {
      id
      year
      scoreType
      min
      max
      avg
    }
  }
`;

export const DepartmentDataFragment = gql`
  fragment DepartmentDataFragment on Department {
    id
    ...DepartmentFragment
    faculty {
      id
      name
      tagId
      university {
        id
        name
      }
    }
    updatedAt
  }
  ${DepartmentFragment}
`;
